import { FC, ReactElement, ReactNode } from 'react'
import { MyInternalLink, MyInternalLinkProps } from 'components/MyLink'
import classNames from 'classnames'

export type ClickableCardInternalLinkProps = MyInternalLinkProps & {
  icon: ReactElement | ReactNode
}

export const ClickableCardInternalLink: FC<ClickableCardInternalLinkProps> = ({ children, icon, className, ...props }) => {
  return (
    <MyInternalLink className={classNames('my-c-clickable-card ds-u-color--secondary ds-u-padding-y--1', className)} {...props}>
      {icon && <span className='ds-u-margin-right--2'>{icon}</span>}
      <span>{children}</span>
    </MyInternalLink>)
}
